import { Box, Button, Container } from '@mui/material';
import { createContext, PropsWithChildren, useContext, useEffect } from 'react';
import { ITitleI18nConf, ITitleI18nNsConf, ITitleI18nTitleConf } from '.';
import { isBuild, isDev, isServer, loadI18nValue, publicRuntimeConfig } from '@fanfanlo';
import { read } from 'fs';
import { useTranslation } from '@fanfanlo';


function Reload(){
  if(!isDev)return <>  </>
  const {t} = useTranslation("app-ui/components/page/content")
  return(
    <Box>
      <Button onClick={() => {window.location.reload()}}>{t("PageContent.refresh")}</Button>
      {new Date().toLocaleString()}
    </Box>
  )
}

const ScrollP = createContext({ x: 0, y: 0 });
let index = 0;
export default function PageContent({ children, titleConf, reload }: {titleConf?:ITitleI18nConf, reload?: boolean} & PropsWithChildren) {
  index++;
  const scroll = useContext(ScrollP);
  const clazz = `${Date.now() + Math.random() * Date.now()}`;
  useEffect(()=>{
    async function loadTitle(){
      if(!titleConf)return
      let title = titleConf.title
      if(titleConf.ns){
        title = await loadI18nValue(titleConf.ns, titleConf.key || "content.title")
      }
      if(!title)return
      document.title = title
    }
    loadTitle()
  }, [])
  useEffect(() => {
    const container = document.getElementsByClassName(clazz)[0];
    if (!container) return;
    container.scrollTop = scroll.y;
    const onScroll = () => {
      var scrollTop = container.scrollTop;
      scroll.y = scrollTop;
    };
    container.removeEventListener('scroll', onScroll);
    container.addEventListener('scroll', onScroll, { passive: true });
    return () => container.removeEventListener('scroll', onScroll);
  }, [clazz, scroll]);
  return (

    <Container className={clazz} sx={{ flexGrow: 1, overflow: 'auto', padding: "0px" }}>
      <Box>
        {(reload || (reload == undefined)) && <Reload />}
        {children}
      </Box>
    </Container>
  );
}
